module.exports = __webpack_public_path__ + "img/down_arrow_icon.24be5507.svg";